define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/reflection",
	"csi/store/_ClientRequestMixin",
	"csi/store/Nodes",
	"csi/xml",
	"SiteAdmin/Locale"
], function(declare, lang, csi, _, reflection, _ClientRequestMixin, Nodes, xml, Locale) {

	var LOCALE_CONFIGURATION = "LocaleConfiguration",
		KEY_SITE = "Site";

	return declare([Nodes, _ClientRequestMixin], {
		bSimpleQueryEngine: true,

		// Boolean: indicates that config resource could be parameterized
		bParameterized: true,

		// String: locale being configured
		configLocale: null,

		// String: index for config resource
		keyConfig: "Config",

		// LocaleResolver: site locale resolvers
		lrBaseSite: null,
		lrConfigSite: null,

		// LocaleResolver: selected locale resolvers
		lrBase: null,
		lrConfig: null,

		// String: section of type resources to display
		typeSection: null,

		getResourceAttribute: function() {
			// summary: return attribute
			return this.typeSection ? Locale.ATTR_TYPES : Locale.ATTR_RESOURCES;
		},

		getResourceKeys: function(/*Node*/node, /*String*/keyContainer) {
			// summary: return array of keys used to persist resource
			if (this.typeSection) {
				return [node.Type, this.typeSection, node.Id];
			}

			return [node.Id];
		},

		onPut: function(/*Node*/node, /*Object*/res) {
			// summary: extension point to populate resources on node
		},

		put: function(/*Node*/node, /*Object?*/directives) {
			// summary: populate Resources when node is added to store
			this._setConfigResource(node, this.keyConfig, false);
			this._setConfigResource(node, KEY_SITE, true);
			this.onPut(node, node.Resources);
			this.inherited(arguments);
		},

		_createNode: function(/*String*/id, /*Object?*/attrs) {
			// summary: create node and populate resources
			var node = xml.nodeCreateClientNode(null, LOCALE_CONFIGURATION);
			var res = {};

			if (attrs) {
				lang.mixin(node, attrs);
			}

			node.Id = id;

			// resolve resource fully (including parameters) to support Find toolbar plugin
			res.__Base__ = this._getResource(node, this.lrBase) || "";

			// resolve resource without substituting parameters to help user understand how resource is formulated
			this.lrBase.bSubstitute = false;
			res.Base = this._getResource(node, this.lrBase) || "";
			node.BaseClass = this.lrBase.rcLastType;
			this.lrBase.bSubstitute = true;

			xml.nodeCreateClientAttr(node, Locale.ATTR_RESOURCES, xml.ATTR_STRINGMAP, res);

			return node;
		},

		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getResourceIfExists(node.Id);
		},

		_onStoreOptions: function(/*Object*/options) {
			// summary: update store options with additional properties
			this.lrBase = Locale.getBaseResolver(options.configLocale);
			this.lrBaseSite = Locale.getBaseResolver();
			this.lrConfig = Locale.getConfigResolver(options.configLocale);
			this.lrConfigSite = Locale.getConfigResolver();
			this.inherited(arguments);
		},

		_resolveData: function(/*Deferred*/dfd) {
			// summary: create node per resource that is not enumeration
			console.assert(!!this.typeSection, "Need to override");

			var lr = this.lrBaseSite;
			var data = [];

			_.each(lr.localeResources.types, function(typeObj, type) {
				// only show enabled classes with an explicit name
				var rc = reflection.getClass(type);
				if (rc?.enabled) {
					var resObj = typeObj[this.typeSection];
					if (resObj) {
						var typeName = lr.getTypeName(type);

						_.each(resObj, function(value, key) {
							data.push(this._createNode(key, {
								Sort: typeName + "." + key,
								Type: type,
								TypeName: typeName
							}));
						}, this);
					}
				}
			}, this);

			dfd.resolve(csi.sort(data, "Sort"));
		},

		_setConfigResource: function(/*Node*/node, /*String*/key, /*Boolean*/bSite) {
			// summary: get resource for config key from resolver
			var lrBase = bSite ? this.lrBaseSite : this.lrBase;
			var lrConfig = bSite ? this.lrConfigSite : this.lrConfig;
			var idCss = "Css" + key;
			var bParam = false;
			var x = this._getResource(node, lrConfig);

			// determine if the resource was configured for a base class of the class at which the resource
			// was configured in the base - if so, then don't use it because the base localization will be used
			// i.e. Product attribute is localized by user, but a Style-specific localization already exists in the base
			var rcBase = node.BaseClass;
			var rcConfig = lrConfig.rcLastType;
			if (rcBase && rcConfig && (rcBase != rcConfig) && rcBase.isDerivedFrom(rcConfig)) {
				x = null;
			}

			if (this.bParameterized && (x == null)) {
				// resource may be parameterized, so check to see parameter was changed even if resource was not
				var y = this._getResource(node, lrBase);

				lrBase.paramResolver = lrConfig;
				x = this._getResource(node, lrBase);
				lrBase.paramResolver = null;

				if ((x != null) && (x != y)) {
					bParam = true;
				} else {
					x = null;
				}
			}

			node[idCss] = bParam;
			node.Resources[key] = x || "";
		}
	});
});